import { Directive, ElementRef, inject, input, OnChanges, SimpleChanges } from '@angular/core';
import { IconLabelPipe } from '../../../../essentials/util/src/pipes/icon-label.pipe';
import { IconNamePipe } from '../../../../essentials/util/src/pipes/icon-name.pipe';

@Directive({
  selector: 'ion-icon[iconName]',
})
export class IonIconDirective implements OnChanges {
  iconName = input.required<string>();

  private el = inject(ElementRef);
  private iconNamePipe = inject(IconNamePipe);
  private iconLabelPipe = inject(IconLabelPipe);

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['iconName']) {
      this.updateIcon();
    }
  }

  private updateIcon(): void {
    const nativeEl = this.el.nativeElement as HTMLIonIconElement;
    const icon = this.iconName();

    nativeEl.src = this.iconNamePipe.transform(icon);

    if (!nativeEl.hasAttribute('aria-label')) {
      nativeEl.setAttribute('aria-label', this.iconLabelPipe.transform(icon));
    }
  }
}
